module.exports = __webpack_public_path__ + "img/binamo-postback.ru.e2eb6c81.jpg";